function extractTopics(messageList) {
    // Kopieren der MessageList in exportierte Objekte, um in der IDE Autocompletion der Konstanten Topics und Messages zu ermöglichen
    const Topics = Object.create(messageList);

    // Restrukturierung der Topic Liste: erwartungskonformes Logging von Topics.TOPICNAME und Messages.TOPICNAME.MESSAGENAME
    for(const topic in messageList) {
        Topics[topic] = topic;
    }
    Object.freeze(Topics);  // kein IE8 Support im Projekt
    return Topics;
}

function extractMessages(messageList) {
    // Kopieren der MessageList in exportierte Objekte, um in der IDE Autocompletion der Konstanten Topics und Messages zu ermöglichen
    const Messages = Object.create(messageList);

    // Restrukturierung der Topic Liste: erwartungskonformes Logging von Topics.TOPICNAME und Messages.TOPICNAME.MESSAGENAME
    for(const topic in messageList) {
        Messages[topic] = {};
        for(const message in messageList[topic]) {
            Messages[topic][message] = `${topic}.${message}`;
        }
        Object.freeze(Messages[topic]);
    }
    Object.freeze(Messages);    // kein IE8 Support im Projekt
    return Messages;
}

export default {
    extractTopics,
    extractMessages
};